<div class="fade-in">
	@if (loading()) {
		<div class="spin-wrapper">
			<nz-spin nzSimple nzSize="large"></nz-spin>
		</div>
	}

	@if (!loading() && urls().length > 0) {
		<div>
			<div class="progress-wrapper">
				@if (preloadProgress() < 100) {
					<nz-progress [nzPercent]="preloadProgress()" [nzShowInfo]="true" nzStatus="active"></nz-progress>
				}
			</div>
			<div class="upper-close-wrapper">
				<button nz-button (click)="onClose.emit()" nzSize="large">
					<span nz-icon nzType="close"></span>
				</button>
			</div>
			<div class="search-wrapper">
				<app-search-form (onSubmit)="search($event)"></app-search-form>
			</div>
			<div class="images-wrapper">
				@for (image of whichUrls(); track image) {
					<div class="image" (click)="selectImageUrl(image)" nz-tooltip [nzTooltipTitle]="image">
						<img [src]="sanitizer.bypassSecurityTrustUrl(image)" alt="Previous image" />
					</div>
				}
			</div>
		</div>
	}

	@if (!loading() && totalImages() === 0) {
		<div class="no-images">
			No previous images found.
			<br />
			<button nz-button nzType="primary" (click)="onClose.emit()" nzShape="circle" nzSize="large">
				<span nz-icon nzType="close"></span>
			</button>
		</div>
	}
</div>
